import React, { useEffect, useState } from "react";
import { Dropdown } from "../common/index.js";

const Enums = ({ item, data, changeFilter, removeFilter, refresh }) => {
  const [value, setValue] = useState();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (item?.defaultFilter && !checked) {
      setValue(item?.defaultFilter);
      setChecked(true);
    }
  }, [item]);
  useEffect(() => {
    if (refresh > 0) {
      setValue();
    }
  }, [refresh]);
  return (
    <>
      <Dropdown
        title={item.title}
        data={[{ value: undefined, title: "هیج کدام" }, ...item.enums]}
        value={item.enums?.find((i) => i.value === value)}
        change={(e) => {
          if (e.value === undefined) {
            removeFilter();
            setValue();
          } else {
            changeFilter({
              name: item.name,
              value: e.value,
              type: "eq",
            });
            setValue(e.value);
          }
        }}
      />
    </>
  );
};

export default React.memo(Enums);
